import React from 'react'
import { useHistory } from 'react-router-dom'
import Card from '../common/Card'
import { getDate } from '../../utils/date'

export default function MotherBabiesSection({ animalData }) {
    const history = useHistory()

    const hasMother = animalData.motherDetail
    const hasBabies = animalData.babiesList && animalData.babiesList.length > 0

    if (!hasMother && !hasBabies) {
        return null
    }

    return (
        <>
            {/* Она маълумотлари */}
            {hasMother && (
                <Card style={{ marginTop: '20px' }}>
                    <h2 className="title is-5 mb-4">
                        <span style={{ marginRight: '8px' }}>👪</span>
                        Онаси
                    </h2>
                    <div
                        className="box"
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            borderRadius: '8px',
                            border: '2px solid transparent'
                        }}
                        onClick={() => history.push(`/animals/${animalData.motherDetail.id}`)}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)'
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'
                            e.currentTarget.style.borderColor = '#3273dc'
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)'
                            e.currentTarget.style.boxShadow = 'none'
                            e.currentTarget.style.borderColor = 'transparent'
                        }}
                    >
                        <div className="columns is-mobile is-vcentered">
                            <div className="column is-narrow">
                                {animalData.motherDetail.imageUrl ? (
                                    <figure className="image is-64x64">
                                        <img
                                            src={animalData.motherDetail.imageUrl}
                                            alt={animalData.motherDetail.identificationNumber}
                                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                                        />
                                    </figure>
                                ) : (
                                    <div
                                        style={{
                                            width: '64px',
                                            height: '64px',
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '32px'
                                        }}
                                    >
                                        📷
                                    </div>
                                )}
                            </div>
                            <div className="column">
                                <p className="title is-6 mb-1">
                                    {animalData.motherDetail.identificationNumber}
                                </p>
                                <div className="tags">
                                    <span className="tag is-info is-light">
                                        {animalData.motherDetail.animalTypeName}
                                    </span>
                                    <span className={`tag ${animalData.motherDetail.status === 'active' ? 'is-success' : 'is-warning'}`}>
                                        {animalData.motherDetail.statusDisplay}
                                    </span>
                                    {animalData.motherDetail.birthDate && (
                                        <span className="tag is-light">
                                            {getDate(animalData.motherDetail.birthDate)}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="column is-narrow">
                                <span className="icon has-text-info">
                                    <ion-icon name="arrow-forward-outline" style={{ fontSize: '24px' }} />
                                </span>
                            </div>
                        </div>
                    </div>
                </Card>
            )}

            {/* Болалар рўйхати */}
            {hasBabies && (
                <Card style={{ marginTop: '20px' }}>
                    <h2 className="title is-5 mb-4">
                        <span style={{ marginRight: '8px' }}>🐾</span>
                        Болалари
                        <span className="tag is-info is-light ml-2">
                            {animalData.babiesCount || animalData.babiesList.length}
                        </span>
                    </h2>
                    <div className="columns is-multiline">
                        {animalData.babiesList.map((baby) => (
                            <div key={baby.id} className="column is-half">
                                <div
                                    className="box"
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        borderRadius: '8px',
                                        border: '2px solid transparent',
                                        height: '100%'
                                    }}
                                    onClick={() => history.push(`/animals/${baby.id}`)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)'
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'
                                        e.currentTarget.style.borderColor = '#48c774'
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)'
                                        e.currentTarget.style.boxShadow = 'none'
                                        e.currentTarget.style.borderColor = 'transparent'
                                    }}
                                >
                                    <div className="columns is-mobile is-vcentered">
                                        <div className="column is-narrow">
                                            {baby.imageUrl ? (
                                                <figure className="image is-64x64">
                                                    <img
                                                        src={baby.imageUrl}
                                                        alt={baby.identificationNumber}
                                                        style={{ objectFit: 'cover', borderRadius: '8px' }}
                                                    />
                                                </figure>
                                            ) : (
                                                <div
                                                    style={{
                                                        width: '64px',
                                                        height: '64px',
                                                        backgroundColor: '#f5f5f5',
                                                        borderRadius: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '32px'
                                                    }}
                                                >
                                                    🐾
                                                </div>
                                            )}
                                        </div>
                                        <div className="column">
                                            <p className="title is-6 mb-1">
                                                {baby.identificationNumber}
                                            </p>
                                            <div className="tags">
                                                <span className={`tag ${baby.gender === 'male' ? 'is-info' : 'is-danger'} is-light`}>
                                                    {baby.genderDisplay}
                                                </span>
                                                <span className="tag is-warning is-light">
                                                    {baby.ageCategoryDisplay}
                                                </span>
                                                <span className={`tag ${baby.status === 'active' ? 'is-success' : 'is-warning'}`}>
                                                    {baby.statusDisplay}
                                                </span>
                                                {baby.birthDate && (
                                                    <span className="tag is-light">
                                                        {getDate(baby.birthDate)}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="column is-narrow">
                                            <span className="icon has-text-success">
                                                <ion-icon name="arrow-forward-outline" style={{ fontSize: '24px' }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>
            )}
        </>
    )
}
